import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

import './style.css';
import Profil from './views/profil';
import Home from './views/home';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBPvkwepCZ69EaFo5Xd3fBt8ef4FNv3Tqk",
  authDomain: "assistgram-4ea13.firebaseapp.com",
  databaseURL: "https://assistgram-4ea13-default-rtdb.europe-west1.firebasedatabase.app", // Add this line
  projectId: "assistgram-4ea13",
  storageBucket: "assistgram-4ea13.appspot.com",
  messagingSenderId: "388878757853",
  appId: "1:388878757853:web:176cd46e5c624ada7fd034",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const db = getDatabase(firebaseApp);

const App = () => {
  return (
    <Router>
      <div>
        <Route component={Profil} exact path="/profil/:userId" />
        <Route component={Home} exact path="/" />
      </div>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'));
